export default function getScoreTextKulturSelbtest(score: number): any {
  if (score >= 90) {
    return {
      title: `Kultur-Vordenker`,
      text: `Starke Leistung! Kultur wird in deiner Organisation bewusst gestaltet und strategisch genutzt. Sie ist klar erkennbar, wirksam und auf hohem Niveau verankert. Nun geht es darum, dieses Niveau zu halten, weiterzuentwickeln und auch in dynamischen Zeiten aufrechtzuerhalten.`,
    };
  }
  if (score >= 75 && score <= 89) {
    return {
      title: `Kultur-Pionier`,
      text: `In deiner Organisation ist Kultur bereits klar spürbar und wird aktiv gestaltet. Vieles trägt schon heute positiv zum Alltag und zur Wirksamkeit bei. Der nächste Schritt liegt in einer noch bewussteren Verankerung und Weiterentwicklung.`,
    };
  }
  if (score >= 50 && score <= 74) {
    return {
      title: `Kultur-Gestalter`,
      text: `Deine Organisation verfügt bereits über tragfähige Ansätze, doch noch nicht alles greift konsistent ineinander. Kultur ist erkennbar, ihre Wirkung bleibt jedoch in Teilen noch ungenutzt. Mit gezielten Impulsen lässt sich die kulturelle Wirksamkeit deutlich stärken.`,
    };
  }
  if (score <= 49) {
    return {
      title: `Kultur-Starter`,
      text: `In deiner Organisation sind erste Grundlagen erkennbar, doch Kultur ist noch nicht durchgängig wirksam verankert. Vieles bleibt punktuell oder uneinheitlich. Jetzt geht es vor allem darum, bewusst anzusetzen und erste klare Entwicklungsschritte zu setzen`,
    };
  }

  return 'Es konnten noch keine Scores berechnet werden, da noch keine Daten vorliegen.';
}
